<template>
  <div class="page-index user-member">
    <div class="toolbar-box">
      <el-select v-if="userInfo.companyList.length > 0" class="search-input2" multiple collapse-tags v-model="form.companyIds" @change="seach" placeholder="请选择公司">
        <el-option v-for="item in userInfo.companyList" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
      <el-date-picker
        v-model="dates"
        class="search-input1"
        type="daterange"
        @change="seach"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :picker-options="pickerOptions">
      </el-date-picker>
      <el-input  class="search-input" size="mini" v-model="form.query" @keyup.enter.native="seach" placeholder="请输入名称或编号" />
      <el-button type="primary" @click="excel">导出</el-button>
    </div>
    <el-table
        ref="userTable"
        :data="list"
        stripe
        size="mini"
        empty-text="暂无数据"
        row-class-name="table-row-cursor"
        header-row-class-name="header-row"
        :height="tableHeight"
        :maxHeight="tableHeight"
        style="width: 100%;">
      <el-table-column
          header-align="center"
          align="center"
          type="index"
          :index="indexMethod"
          width="50"
          label="#">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="labelName"
          label="标签名称">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="productName"
          label="产品名称">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="productCode"
          label="产品编号">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="companyName"
          label="公司名称">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="typeName"
          label="班次">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="userName"
          label="打印人员">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="printDate"
          label="领用日期">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="printNum"
          label="打印数量">
      </el-table-column>
    </el-table>

    <el-pagination
        :current-page.sync="pageIndex"
        @current-change="pageChange"
        layout="->, total, prev, pager, next"
        :page-size="pageSize"
        :total="total"
        class="pagination">
    </el-pagination>
  </div>
</template>

<script type="text/ecmascript-6">
  import { tableMixin } from '../../mixins/table'
  import { formatDate } from '../../utils/common'
  import { mapGetters } from 'vuex'
  import { apiPrintReport, apiPrintExcel } from '../../api/report'

  export default {
    mixins: [tableMixin],
    name: 'userInfo',
    data() {
      return {
        dialogVisible: false,
        list: [],
        pageIndex: 1,
        total: 0,
        id: '',
        dates: [],
        form: {
          companyIds: [],
          endDate: '',
          query: '',
          startDate: ''
        },
        pickerOptions: {
          shortcuts: [{
            text: '当月',
            onClick(picker) {
              const end = new Date()
              const start = new Date(formatDate(end, 'YYYY-MM-01'))
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }]
        }
      }
    },
    computed: {
      ...mapGetters([
        'userInfo',
        'roles',
        'currentRoles'
      ])
    },
    created() {
      const end = new Date()
      const start = new Date(formatDate(end, 'YYYY-MM-01'))
      this.dates[0] = start
      this.dates[1] = end
      if (this.userInfo.companyList) {
        this.form.companyIds[0] = parseInt(this.userInfo.companyList[0].id)
      }
      this._getList()
    },
    activated() {},
    methods: {
      indexMethod(index) {
        return (this.pageIndex - 1) * 20 + index + 1
      },
      // 翻页
      pageChange(pageIndex) {
        this.pageIndex = pageIndex
        this._getList(pageIndex)
      },
      // 搜索
      seach() {
        this.pageIndex = 1
        this._getList()
      },
      // 导出
      excel() {
        if (!this.dates) {
          this.$message({
            type: 'warning',
            message: '请选择日期'
          })
          return
        }
        apiPrintExcel(this.form.companyIds, formatDate(this.dates[0], 'YYYY-MM-DD'), formatDate(this.dates[1], 'YYYY-MM-DD'), this.form.query)
      },
      // 获取列表
      _getList(pageIndex = 1) {
        if (!this.dates) {
          this.$message({
            type: 'warning',
            message: '请选择日期'
          })
          return
        }
        let searchCondition = {
          companyIds: this.form.companyIds,
          startDate: formatDate(this.dates[0], 'YYYY-MM-DD'),
          endDate: formatDate(this.dates[1], 'YYYY-MM-DD'),
          query: this.form.query
        }
        apiPrintReport(searchCondition, pageIndex).then(data => {
          this.list = data.data.data
          this.total = data.data.total
        })
      }
    }
  }
</script>

<style lang="stylus">
  .page-index.user-member
    .btn-left
      background #A5CE1C
      color #fff
    .el-table
      .has-gutter
        th
          background #F5F7FA
          border-right 1px solid #EBEEF5
          border-top 1px solid #ebeef5
    .toolbar-box
      display flex
      margin 10px 0
      .search-input1
        margin-right 10px
        width  250px
      .search-input2
        margin-right 10px
      .search-input
        width 150px
        margin-right 10px
        .el-input__inner
          height 36px
          line-height 36px
      .select-box
        width 120px
        margin-right 10px
    .upload
      .el-upload
        width 100%
        .el-upload-dragger
          width 100%
</style>
